// ═══════════════════════════════════════════════════════════════
// Map Engine — Drawing Primitives
// ═══════════════════════════════════════════════════════════════

/** Trace and optionally fill/stroke a rounded rectangle */
export function roundedRect(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  w: number,
  h: number,
  r: number,
  fill: boolean,
  stroke: boolean,
) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.lineTo(x + w - r, y);
  ctx.quadraticCurveTo(x + w, y, x + w, y + r);
  ctx.lineTo(x + w, y + h - r);
  ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
  ctx.lineTo(x + r, y + h);
  ctx.quadraticCurveTo(x, y + h, x, y + h - r);
  ctx.lineTo(x, y + r);
  ctx.quadraticCurveTo(x, y, x + r, y);
  ctx.closePath();
  if (fill) {
    ctx.fill();
  }
  if (stroke) {
    ctx.stroke();
  }
}

/** Draw the repeating dot grid that covers the full viewport */
export function drawDotGrid(
  ctx: CanvasRenderingContext2D,
  width: number,
  height: number,
  offsetX: number,
  offsetY: number,
  scale: number,
  gridSize: number,
  color: string,
) {
  // The brand rebrand disables the grid by setting `THEME.gridDot` to
  // "transparent". Short-circuit so we don't pay for thousands of
  // invisible arc() calls per frame.
  if (color === "transparent") {
    return;
  }
  const gs = gridSize * scale;
  const startX = offsetX % gs;
  const startY = offsetY % gs;
  const radius = Math.max(0.7, 0.9 * scale);

  ctx.fillStyle = color;
  for (let x = startX; x < width; x += gs) {
    for (let y = startY; y < height; y += gs) {
      ctx.beginPath();
      ctx.arc(x, y, radius, 0, Math.PI * 2);
      ctx.fill();
    }
  }
}
